import React from "react";

const Footer = ({ left, leftMiddle, rightMiddle, right }) => {
    return (
        <div className="footer has-background-grey-dark has-text-light">
            <div className="container">
                <div className="columns">
                    <div className="column is-3">{left}</div>
                    <div className="column is-3">{leftMiddle}</div>
                    <div className="column is-3">{rightMiddle}</div>
                    <div className="column is-3">{right}</div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
